export function usZipcodeFilter(zipcode) {
  const regex = /[^\d-]+/g;
  return zipcode.replace(regex, '');
}
